<template>
  <div class="my-2 pa-3 encarte-card">
    <span class="pa-1 title">Clientes levados para a loja</span>
    <v-container fluid class="pa-1">
      <v-layout>
        <v-flex xs6>
          <v-list class="my-3">
            <v-list-item>
              <span class="list-item"
                >{{ items[0].text }} <strong class="ml-2">{{ items[0].value | localeString }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[1].text }} <strong class="ml-2">{{ items[1].value | localeString }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[2].text }} <strong class="ml-2">{{ items[2].value | localeString(1) | percent }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[3].text }} <strong class="ml-2">{{ items[3].value | localeString(2) }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[4].text }} <strong class="ml-2">{{ items[4].value | localeString(1) }}</strong></span
              >
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs1 offset-xs1> </v-flex>
        <v-flex xs4>
          <encarte-chart class="chart" :chartData="chartData" is-integer />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EncarteChart from '@/modules/campanhas/resultados-encarte/views/pages/EncarteChart.vue'
import { mapGetters } from 'vuex'
import { colors } from '@/config/colors.js'

export default {
  components: {
    EncarteChart,
  },
  computed: {
    ...mapGetters(['cuponsTotal', 'cuponsComEncarte', 'cuponsCliente', 'clienteEncarte', 'percentualCupons']),
    items() {
      return [
        {
          text: 'Total de cupons no período',
          value: this.cuponsTotal,
        },
        {
          text: 'Cupons com pelo menos um produto do encarte',
          value: this.cuponsComEncarte,
        },
        {
          text: 'Percentual de cupons com produto(s) do encarte',
          value: this.percentualCupons,
          isPercent: true,
        },
        {
          text: 'Média estimada de compras por cliente no encarte',
          value: this.cuponsCliente,
        },
        {
          text: 'Quantidade estimada de clientes trazidos pelo encarte',
          value: this.clienteEncarte,
        },
      ]
    },
    chartData() {
      return {
        labels: ['Total', 'Com Encarte'],
        datasets: [
          {
            label: 'Quantidade',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [this.cuponsTotal, this.clienteEncarte],
            fill: false,
            datalabels: { display: true },
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss">
.encarte-card {
  .chart {
    max-height: 350px;
  }
}
</style>
